import { Info } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import AppHeader from "@/components/AppHeader";

interface EmptyStateProps {
  alert: boolean;
  onAddCourse: () => void;
  view: "ready" | "done" | "flagged" | "archived";
}

export const EmptyState = ({ alert, onAddCourse, view }: EmptyStateProps) => {
  const texts = {
    ready: {
      title: alert ? "Getting started" : "No submissions found",
      description: alert ? "First, add a course and create an assessment." : "Submissions ready for grading will appear here.",
      header: {
        primary: "Welcome",
        secondary: "to Claire"
      }
    },
    done: {
      title: "No graded submissions found",
      description: "Graded submissions will appear here.",
      header: {
        primary: "No submission",
        secondary: "graded"
      }
    },
    flagged: {
      title: "No flagged submissions found",
      description: "Flagged submissions will appear here.",
      header: {
        primary: "No submission",
        secondary: "flagged"
      }
    },
    archived: {
      title: "Archived submissions",
      description: "Archived submissions will appear here.",
      header: {
        primary: "No submission",
        secondary: "archived"
      }
    },
  };

  const text = texts[view];

  return (
    <>
      <AppHeader primary={text.header.primary} secondary={text.header.secondary} />

      <Alert variant="default" className="mt-6">
        <Info />
        <div className="flex gap-2 items-center justify-between">
          <div className="flex flex-col gap-1">
            <AlertTitle>{text.title}</AlertTitle>
            <AlertDescription>{text.description}</AlertDescription>
          </div>
          {alert && (
            <Button
              className="h-6 rounded-md px-3 py-2 text-xs font-medium"
              size="sm"
              onClick={onAddCourse}
            >
              Add course
            </Button>
          )}
        </div>
      </Alert>
    </>
  );
};
